import {
  useEffect,
  useState
} from "react";

import API from "../../services/api";

function StockReport() {

  const [products,
    setProducts] =
    useState([]);

  const [search,
    setSearch] =
    useState("");

  const [totalValue,
    setTotalValue] =
    useState(0);

  useEffect(() => {
    loadReport();
  }, [search]);

  const loadReport =
    async () => {

      try {

        const res =
          await API.get(
            `/reports/stock-report?search=${search}`
          );

        setProducts(
          res.data.products
        );

        setTotalValue(
          res.data.totalInventoryValue
        );

      } catch (err) {
        console.log(err);
      }

    };

  return (
    <div>

      <div
        className="
        flex
        flex-col
        md:flex-row
        justify-between
        gap-4
        mb-6
      "
      >

        <h1
          className="
          text-4xl
          font-bold
        "
        >
          Stock Report
        </h1>

        <input
          placeholder="Search Product..."
          value={search}
          onChange={(e)=>
            setSearch(
              e.target.value
            )
          }
          className="
          p-3
          bg-[#111]
          border
          border-yellow-500/20
          rounded-xl
          md:w-80
        "
        />

      </div>

      {/* TOTAL */}

      <div
        className="
        bg-[#111]
        border
        border-yellow-500/20
        rounded-2xl
        p-6
        mb-6
      "
      >

        <h3
          className="
          text-zinc-400
        "
        >
          Total Inventory Value
        </h3>

        <h2
          className="
          text-4xl
          font-bold
          text-yellow-400
          mt-2
        "
        >
          ₹
          {Number(
            totalValue
          ).toFixed(2)}
        </h2>

      </div>

      {/* MOBILE */}

      <div
        className="
        md:hidden
        space-y-4
      "
      >

        {products.map(
          (item) => (

            <div
              key={item.id}
              className="
              bg-[#111]
              rounded-2xl
              p-4
              border
              border-yellow-500/10
            "
            >

              <p>
                <b>
                  Product:
                </b>
                {" "}
                {item.name}
              </p>

              <p>
                <b>
                  Category:
                </b>
                {" "}
                {item.category_name}
              </p>

              <p>
                <b>
                  Stock:
                </b>
                {" "}
                {item.stock}
              </p>

              <p>
                <b>
                  Purchase:
                </b>
                {" "}
                ₹
                {item.purchase_price}
              </p>

              <p>
                <b>
                  Selling:
                </b>
                {" "}
                ₹
                {item.selling_price}
              </p>

              <p
                className="
                text-yellow-400
                font-bold
                mt-2
              "
              >
                Value:
                ₹
                {item.stock_value}
              </p>

            </div>

          )
        )}

      </div>

      {/* DESKTOP */}

      <div
        className="
        hidden
        md:block
        bg-[#111]
        rounded-2xl
        overflow-hidden
      "
      >

        <div
          className="
          overflow-x-auto
        "
        >

          <table
            className="
            w-full
          "
          >

            <thead>

              <tr
                className="
                border-b
                border-yellow-500/20
              "
              >

                <th className="p-4 text-left">
                  Product
                </th>

                <th className="p-4 text-left">
                  Category
                </th>

                <th className="p-4 text-center">
                  Stock
                </th>

                <th className="p-4 text-center">
                  Purchase
                </th>

                <th className="p-4 text-center">
                  Selling
                </th>

                <th className="p-4 text-center">
                  Value
                </th>

              </tr>

            </thead>

            <tbody>

              {products.map(
                (item) => (

                  <tr
                    key={item.id}
                    className="
                    border-b
                    border-yellow-500/10
                  "
                  >

                    <td className="p-4">
                      {item.name}
                    </td>

                    <td className="p-4">
                      {item.category_name}
                    </td>

                    <td className="p-4 text-center">
                      {item.stock}
                    </td>

                    <td className="p-4 text-center">
                      ₹
                      {item.purchase_price}
                    </td>

                    <td className="p-4 text-center">
                      ₹
                      {item.selling_price}
                    </td>

                    <td
                      className="
                      p-4
                      text-center
                      text-yellow-400
                      font-bold
                    "
                    >
                      ₹
                      {item.stock_value}
                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}

export default StockReport;